import { fromTime } from "@hex-insights/core";

export function minutesToDate(minutes: number, date = new Date()) {
	const newDate = new Date(date);
	return fromTime(minutes, "minute", newDate);
}
